module.exports = __webpack_public_path__ + "static/offer-d-5-new-0f1cf41161fa9804b3e1b635da2057a0.jpg";